import React, { useState } from 'react'

import { useStore } from '../../../functions/store'
import AddCompetition from './AddCompetition'
import CompetitionHistory from './CompetitionHistory'

interface DashboardCompetitionProps {
  fighterUuid?: string
}

export default function DashboardCompetition({
  fighterUuid,
}: DashboardCompetitionProps) {
  const user = useStore((state) => state)
  const [showAddModal, setShowAddModal] = useState(false)

  const phoneNumber = user.phoneNumber

  return (
    <div className="w-full max-w-6xl mx-auto">
      <CompetitionHistory
        fighterUuid={fighterUuid}
        phoneNumber={phoneNumber}
        showActions={true}
        onAddClick={() => setShowAddModal(true)}
      />

      {showAddModal && (
        <AddCompetition
          onClose={() => setShowAddModal(false)}
          onSuccess={() => {
            // Refresh will happen automatically via store
          }}
        />
      )}
    </div>
  )
}
